import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Fragment, useEffect, useState } from 'react';
import styled, { keyframes } from 'styled-components';
import ClassNote from '@crehana/icons/ClassNote';
import { colors } from '@crehana/ui';
import { usePlaybackContext } from "../../../context/Playback";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var highlight = function highlight(_ref) {
  var theme = _ref.theme;
  return keyframes(["\n  0% {\n    background-color: ", ";\n  }\n  100% {\n    background-color: ", ";\n  }\n"], theme.colors.gray['dark-70'], theme.colors.base['main-80']);
};
var NoteButton = /*#__PURE__*/styled.button.withConfig({
  componentId: "sc-1ig6yjl-0"
})(["\n  &.highlighted {\n    animation: ", " 1s ease-in-out forwards 0.1s;\n  }\n"], highlight);
var ClassNotes = function ClassNotes(_ref2) {
  var classNotes = _ref2.classNotes;
  var _usePlaybackContext = usePlaybackContext(),
    videoId = _usePlaybackContext.videoId,
    duration = _usePlaybackContext.duration;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    timelineSections = _useState2[0],
    setTimelineSections = _useState2[1];
  useEffect(function () {
    setTimelineSections(Array.from({
      length: 20
    }).map(function (_, index) {
      var sectionDuration = duration / 20;
      var start = sectionDuration * index;
      var end = sectionDuration * index + sectionDuration;
      return {
        start: start,
        end: end,
        cuepoints: classNotes.filter(function (c) {
          return c.timePosition >= start && c.timePosition < end;
        }).map(function (c) {
          return _objectSpread(_objectSpread({}, c), {}, {
            left: "".concat(c.timePosition / duration * 100, "%")
          });
        }).sort(function (a, b) {
          return a.timePosition - b.timePosition;
        })
      };
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [classNotes.length, duration, videoId]);
  return /*#__PURE__*/_jsx("div", {
    className: "flex absolute left-0 h-8 w-full z-1",
    children: timelineSections.map(function (section, i) {
      var firstCuepoint = section.cuepoints.length ? section.cuepoints[0] : undefined;
      if (firstCuepoint) {
        var highlightedNote = classNotes.find(function (cn) {
          return cn.highlighted;
        });
        var isHighlighted = highlightedNote ? section.cuepoints.find(function (cp) {
          return cp.originalId === highlightedNote.originalId;
        }) : false;
        return /*#__PURE__*/_jsxs(Fragment, {
          children: [/*#__PURE__*/_jsxs(NoteButton, {
            type: "button",
            className: "absolute flex items-center bg-base-main-80 text-white font-subtitle3 focus:outline-none".concat(isHighlighted ? ' highlighted' : ''),
            style: {
              bottom: '16px',
              left: firstCuepoint.left,
              transform: 'translateX(-50%)'
            },
            onClick: firstCuepoint.onClick,
            children: [/*#__PURE__*/_jsx(ClassNote, {
              size: 24,
              color: colors.white
            }), section.cuepoints.length > 1 ? /*#__PURE__*/_jsx("span", {
              className: "px-4",
              children: section.cuepoints.length
            }) : null]
          }), /*#__PURE__*/_jsx("button", {
            type: "button",
            className: "absolute bottom-0 w-8 h-8 bg-gray-dark focus:outline-none",
            style: {
              left: firstCuepoint.left,
              transform: 'translateX(-50%)'
            },
            onClick: firstCuepoint.onClick,
            "aria-label": section.cuepoints.length > 1 ? "".concat(section.cuepoints.length, " apuntes en la clase") : 'Apunte en la clase'
          })]
        }, "cuepoint-".concat(i * 1));
      }
      return null;
    })
  });
};
export default ClassNotes;